<template>
  <div
    id="data-management"
    class="page page-data-management"
  >
    <!--    <content-spinner :show="folders.loading" text="Please wait..." class="h-100"/>-->
    <div class="page-toolbar bg-white shadow-sm p-3">
      <h4 class="mb-0">
        <font-awesome-icon :icon="['fas', folderData.data.folderIcon || 'folder']" />
        {{ folderData.data.name }}
      </h4>
      <div>
        <b-button
          v-if="canCreate(folderData.data)"
          size="sm"
          variant="outline-secondary"
          :to="{name: 'dataManagementBuilder.create', query: {folderUuid: folderData.data.uuid}}"
        >
          <font-awesome-icon :icon="['fas', 'plus']" />
          Create new Table
        </b-button>
        <b-button
          v-if="canEdit(folderData.data)"
          size="sm"
          variant="outline-primary"
          class="ml-3"
          @click="showEditFolderModal(folderData.data)"
        >
          <font-awesome-icon :icon="['fas', 'pencil-alt']" />
          Edit Folder
        </b-button>
        <b-button
          v-if="canManagePermissions(folderData.data)"
          size="sm"
          variant="outline-primary"
          class="ml-3"
          :to="{name: 'dataManagementPermissions', params: {itemId: folderData.data.uuid, type: permissionItemTypes.folder}}"
        >
          <font-awesome-icon :icon="['fas', 'key']" />
          Manage Permissions
        </b-button>
        <b-button
          v-if="canDelete(folderData.data)"
          size="sm"
          variant="outline-danger"
          class="ml-3"
          @click="deleteFolderFromList(folderData.data)"
        >
          <font-awesome-icon :icon="['fas', 'trash']" />
          Delete Folder
        </b-button>
      </div>
    </div>
    <div
      id="pageContent"
      class="page-content p-4"
    >
      <no-content
        :show="folderData.data.tables && !folderData.data.tables.length"
        text="There are no tables in this folder"
      />
      <div class="row mb-3 p-2">
        <div
          v-for="table in folderData.data.tables"
          :key="table.id"
          class="card-wrapper m-2"
        >
          <TableCard
            :table="table"
            :folder="folderData.data"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {createNamespacedHelpers} from 'vuex';
import ContentSpinner from '../../../../core/components/ContentSpinner';
import TableCard from '../../components/TableCard';
import FolderModal from './modals/FolderModal';
import { UNSET_FOLDER_LIST} from '../../../../store/modules/data-management/mutation-types';
import NoContent from '../../../../core/components/NoContent';

const {mapState, mapActions, mapMutations} = createNamespacedHelpers('dataManagement');

export default {
  name: 'FolderView',
  components: {NoContent, FolderModal, TableCard, ContentSpinner},
  data() {
    return {
      groups: [],
    };
  },
  computed: {
    ...mapState(['folderData']),
    ...mapState({
      permissionItemTypes: state => state.permissionItemTypes,
    }),
  },
  methods: {
    ...mapActions(['getFolderData', 'getFolders', 'showFolderModal', 'addTable', 'deleteFolder', 'showFolderModal']),
    ...mapMutations([UNSET_FOLDER_LIST]),
    async deleteFolderFromList(folder) {
      if (folder.tables.length > 0) {
        return this.$toasted.error(`Folder has ${folder.tables.length} table(s) and can not be deleted`, {
          duration: TOASTER_DURATION,
        });
      }

      const confirm = await this.$confirm('Deleting folder...', `You are deleting folder "${folder.folderName}". Are you sure you want to continue?`);
      if (confirm) {
        const {success} = await this.deleteFolder(folder);
        if (success) {
          this.$toasted.success(`Folder "${folder.folderName}" was deleted`, {
            duration: TOASTER_DURATION,
          });
        }
      }
    },
    showEditFolderModal(folder) {
      this.showFolderModal(folder);
    },
    canCreate(folder) {
      return true; //for now
      return ['write'].includes(folder.currentUserPermission);
    },
    canEdit(folder) {
      return true; //for now
      return ['write'].includes(folder.currentUserPermission);
    },
    canDelete(folder) {
      return true; //for now
      return ['write'].includes(folder.currentUserPermission);
    },
    canManagePermissions(folder) {
      return true; //for now
      return ['write'].includes(folder.currentUserPermission);
    },
  },
  mounted() {
    this.getFolderData(this.$route.params.folderUuid);
  },
  destroyed() {
    this[UNSET_FOLDER_LIST]();
  },
};
</script>

<style scoped>

</style>